// extracted by mini-css-extract-plugin
export default {"overflowHidden":"Jcw6EsD3QJ_6bvyifjd3","suggestionsDropdown":"WkStJpwev3jZqLbzhZaA"};